import React from 'react';
import { WavesIcon } from 'lucide-react';
import { collectionChecklist } from '../data/content';
import { CheckItem } from './CheckItem';
export function ProductIntro() {
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-155" data-mp="1noeb2jkstspx">
      <h2 className="mx-auto max-w-[620px] font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-navy md:text-[24px]" data-id="element-156" data-mp="1nqinjpwrk01t">
        The complete 6-in-1 aqua fitness class system
      </h2>
      <p className="mt-1.5 font-heading text-[28px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-brand md:text-[38px]" data-id="element-157" data-mp="2lbwq2c51zr2d">
        <WavesIcon className="mr-2 inline h-7 w-7 -translate-y-1 text-gold md:h-9 md:w-9" strokeWidth={2.5} aria-hidden data-id="element-158" data-mp="26lz29xb1d3dp" />
        AQUA CLASS HUB™
      </p>
      <p className="mt-1 font-heading text-[13px] font-extrabold uppercase text-navy md:text-[15px]" data-id="element-159" data-mp="2zbo1q683kvd7">
        Complete Aqua Fitness Bundle
      </p>
      <p className="mt-1.5 font-heading text-[11px] font-bold uppercase leading-tight tracking-[0.1em] text-goldDark md:text-[12px]" data-id="element-160" data-mp="34364mztol60t">
        Ready-to-teach classes for aqua fitness &amp; water aerobics instructors
      </p>
      <p className="mt-1 text-[13px] leading-[1.35] text-ink md:text-[14px]" data-id="element-161" data-mp="pieznc1v66t8">
        Cardio • Strength • Intervals • Choreography • Mixed Levels • Circuits
      </p>
      <p className="mt-1 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-162" data-mp="zdqhi38kju57">
        6 Main Volumes + 5 FREE Professional Bonuses
      </p>

      <h3 className="mt-4 font-heading text-[15px] font-extrabold uppercase leading-tight text-navy md:text-[17px]" data-id="element-163" data-mp="187bw9mkqhbem">
        Everything organized into one complete collection
      </h3>
      <ul className="mt-2.5 grid gap-x-6 gap-y-1 text-left text-[14px] leading-[1.35] text-ink sm:grid-cols-2 md:text-[15px]" data-id="element-164" data-mp="1i59kia2lf878">
        {collectionChecklist.map(item => <CheckItem key={item} data-id="element-165" data-mp="3ovz775gkrwz0">{item}</CheckItem>)}
      </ul>

      <div className="mt-4 border-t border-line pt-3" data-id="element-166" data-mp="3jxxs0vm9shst">
        <p className="font-heading text-[18px] font-extrabold uppercase leading-tight text-navy md:text-[22px]" data-id="element-167" data-mp="dfdte0ixwxad">
          72 complete classes + 12 quick workout combos
        </p>
        <p className="mt-1 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[14px]" data-id="element-168" data-mp="hj21qlfebwwo">
          504 pages of practical instructor resources
        </p>
      </div>
    </section>;
}